import { put, call } from 'redux-saga/effects'

import { BFFAgent } from '../../../../common/BFFAgent'
import {
  STOCK_DICTIONARY_FETCH_CAR_LOTS_SUCCESS,
  STOCK_DICTIONARY_FETCH_CAR_LOTS_FAILURE
} from '../constants'

export function* getDictionaryCarlots() {
  try {
    const dictionaryCarLots = yield call(
      BFFAgent.Stock.Dictionary.getDictionaryCarlots
    )

    yield put({
      type: STOCK_DICTIONARY_FETCH_CAR_LOTS_SUCCESS,
      data: dictionaryCarLots
    })
  } catch (error) {
    yield put({
      type: STOCK_DICTIONARY_FETCH_CAR_LOTS_FAILURE,
      data: { error }
    })
  }
}
